import $  from 'jquery'
import objectFitImages from 'object-fit-images';

export default class IAInit {
    constructor() {
        this.checkMSIEVersion()
        $(document).ready(function () {

            objectFitImages();
            // Menu mobile
            let isOpen = false;

            $(document).on('click', '.ia-block-navigation__toggle input[type="button"]', function(event) {
                var $toggle = $(this).parent();
                var $content = $toggle.next('.ia-block-navigation__content');
                isOpen = !isOpen;
                if (isOpen) {
                    $('html').addClass('no-scroll');
                    $content.after('<div class="ia-block-navigation__outer"></div>');
                    $content.addClass('is-open');
                    document.querySelector('#nav-btn').setAttribute('aria-expanded', true)
                } else {
                    $('html').removeClass('no-scroll');
                    $content.removeClass('is-open');
                    $('.ia-block-navigation__outer').remove();
                    document.querySelector('#nav-btn').setAttribute('aria-expanded', false)
                }
            });
        
            $(document).on('click', '.ia-block-navigation__outer', function(event) {
                var $toggle = $(this).parent().find('.ia-block-navigation__toggle');
                $toggle.find('input[type="button"]').click();
            });
        });
    }

    checkMSIEVersion() {
        const ua = window.navigator.userAgent;
        const msie = ua.indexOf("MSIE ");
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            const headerElem = document.querySelector('.section-header');
            const headerHeight = headerElem.clientHeight;
            headerElem.nextElementSibling.style.marginTop = headerHeight + 'px';
        }
        return false;
    }
}